import api from '@/shared/api';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import DataCacheService from '@/shared/services/DataCacheService';
export const useUpdateTwoFaRequired = () => {
    const intl = useIntl();
    const { mutateAsync, isLoading } = useMutation((twoFaRequired) => api.base.put('/api/settings/TwoFa', { twoFaRequired }), {
        onSuccess: (_result, twoFaRequired) => {
            const dataCache = DataCacheService.getDataCache();
            if (dataCache) {
                dataCache.twoFaRequired = twoFaRequired;
            }
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { updateTwoFaRequired: mutateAsync, isLoading };
};
